export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új felettes',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        supervisorActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új páciens hozzárendelése',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'assignPatientToSupervisor'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, 
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-user-plus"></i>',
                title: 'Páciens hozzárendelése',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'assignPatient'
            },
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyRow'
            }, {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            }, 
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        superVisorRowActions: [
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteSupervisorPatientRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "supervisorName",
                label: "Név ",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "employeeId",
                label: "Vállalati azonosító",
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: false,
            },
            {
                name: "partnerHierarchy",
                label: "Céges hierarchia",
                visibility: true,
                formVisible: false,
            },
            {
                name: "email",
                label: "E-mail cím",
                visibility: true,
                formType: 'email',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "phone",
                label: "Telefonszám",
                visibility: true,
                formType: "tel",
                formSize: 4,
                formVisible: true,
                formRequired: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
            {
                name: "originalCompanyIdentifier",
                label: "Eredeti vállalati azonosító",
                visibility: false,
                formVisible: false,
            }
        ],
        supervisorHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formVisible: false,
            },
            {
                name: "patientName",
                label: "Név",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "employeeId",
                label: "Vállalati azonosító",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "patientTaj",
                label: "TAJ",
                visibility: true,
                filter: {
                    type: "simple",
                },
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "partnerHierarchy",
                label: "Céges hierarchia",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "statusName",
                label: "Státusz",
                filter: {
                  type: "simple",
                },
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ]
    }
}
